import React, { Component } from 'react';
import _ from 'lodash';
import axios from 'axios';

import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import ReportStore from '../../stores/ReportStore';
import AfterSaveLoading from '../../components/AfterSaveLoading';
import { monthNames, yearList } from '../../utils/dateHelper';

export default class UsageReportPage extends Component {
  constructor() {
    super()

    this.state = {
      isDataFetched: true,
      start_date: moment(),
      end_date: moment(),
      results: {},
      month_names: monthNames,
      month: moment().month() + 1,
      year_list: yearList,
      year: moment().year(),
      result_start_date: null,
      result_end_date: null,
    }

    this.onChange = this.onChange.bind(this);
    this.changeStartDate = this.changeStartDate.bind(this);
    this.changeEndDate = this.changeEndDate.bind(this);
    this.handleSubmitDateRange = this.handleSubmitDateRange.bind(this);
    this.handleSubmitMonthYear = this.handleSubmitMonthYear.bind(this);
    this.handleDownloadDateRange = this.handleDownloadDateRange.bind(this);
    this.handleDownloadMonthYear = this.handleDownloadMonthYear.bind(this);
    this.renderRow = this.renderRow.bind(this);
    this.renderList = this.renderList.bind(this);
  }

  componentDidMount() {
  }

  handleSubmitDateRange(){
    this.setState({isDataFetched: false});

    ReportStore.request({
      method: 'POST',
      action: 'usage_report',
      data: {
        start_date: this.state.start_date,
        end_date: this.state.end_date
      }
    }).then((resp)=>{
      const results = _.get(resp.data, 'data', {});
      const included = _.get(resp.data, 'included', {});

      this.setState({ 
        results: results, 
        result_start_date: included.start_date, 
        result_end_date: included.end_date
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  handleSubmitMonthYear(){
    this.setState({isDataFetched: false});

    ReportStore.request({
      method: 'POST',
      action: 'usage_report',
      data: {
        month: this.state.month,
        year: this.state.year
      }
    }).then((resp)=>{
      const results = _.get(resp.data, 'data', {});
      const included = _.get(resp.data, 'included', {});

      this.setState({ 
        results: results, 
        result_start_date: included.start_date, 
        result_end_date: included.end_date
      });
    }).then(()=>{
      this.setState({isDataFetched: true});
    });
  }

  onChange(event){
    const field_name = event.target.name;
    const value = event.target.value;

    this.setState({
      [field_name]: value
    });
  }

  changeStartDate(date){
    this.setState({start_date: date});
  }

  changeEndDate(date){
    this.setState({end_date: date});
  }

  handleDownloadDateRange(){
    axios({
      method:'POST',
      url: '/api/v1/reports/usage_report',
      responseType:'arraybuffer',
      cache: false,
      data: {
        start_date: this.state.start_date || '',
        end_date: this.state.end_date || '',
        response_type: 'csv'
      }
    }).then(function(response) {
      let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' } )
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'รายงานการใช้งานระบบ.csv'
      link.click()
    });
  }

  handleDownloadMonthYear(){
    axios({
      method:'POST',
      url: '/api/v1/reports/usage_report',
      responseType:'arraybuffer',
      cache: false,
      data: {
        month: this.state.month || '',
        year: this.state.year || '',
        response_type: 'csv'
      }
    }).then(function(response) {
      let blob = new Blob([response.data], { type: 'application/vnd.ms-excel' } )
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'รายงานการใช้งานระบบ.csv'
      link.click()
    });
  }

  renderRow(value, key){
    return (
      <div className='col-12' key={`${key}-${Math.random().toString(36)}`}>
        <div className='row'>
          <div className='col-md-6'>{key}</div>
          <div className='col-md-6'>{value} ครั้ง</div>
        </div>
      </div>
    )
  }

  renderList(value, key){
    return (
      <div className='row mb-2' key={key}>
        <div className='col-6'>
          - {key}
        </div>
        <div className='col-6'>
          {value} ครั้ง
        </div>
      </div>
    )
  }

  render(){
    const { 
      isDataFetched,
      start_date, 
      end_date,
      results,
      month_names,
      month,
      year_list,
      year,
    } = this.state;

    return (
      <div>
        <h3>รายงานการใช้งานระบบ</h3>

        {!isDataFetched && <AfterSaveLoading />}

        <div className='card mb-4'>
          <div className='p-2'>

            <div className='row'>
              <div className='col-md-2'>จากวันที่:
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  selected={start_date}
                  className='form-control form-control-sm'
                  placeholderText={'DD/MM/YYYY'}
                  onChange={this.changeStartDate} />
              </div>
              <div className='col-md-2'>ถึงวันที่:
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  selected={end_date}
                  className='form-control form-control-sm'
                  placeholderText={'DD/MM/YYYY'}
                  onChange={this.changeEndDate} />
              </div>
              <div className='col-md-4'>
                <p>&nbsp;</p>
                <button type='button' className='btn btn-success mr-2' onClick={this.handleSubmitDateRange}>ค้นหาจากช่วงวันที่</button>
                <button type='button' className='btn btn-success' onClick={this.handleDownloadDateRange}>พิมพ์จากช่วงวันที่</button>
              </div>
            </div>
            
          </div>
        </div>
        <div className='card mb-4'>
          <div className='p-2'>
            <div className='row'>
              <div className='col-md-2 mb-2 mb-md-0'>
                ประจำปี:
                <select 
                  className='form-control form-control-sm'
                  name='year'
                  value={year}
                  onChange={this.onChange}>
                  {_.map(yearList, function(year, index){
                    return <option key={index} value={year.value}>{year.label}</option>
                  })}
                </select>
              </div>

              <div className='col-md-2 mb-2 mb-md-0'>
                ประจำเดือน:
                <select 
                  className='form-control form-control-sm'
                  name='month'
                  value={month}
                  onChange={this.onChange}>
                  {_.map(month_names, function(month_name, index){
                    return <option key={index} value={month_name.value}>{month_name.label}</option>
                  })}
                </select>
              </div>

              <div className='col-md-4'>
                <p>&nbsp;</p>
                <button type='button' className='btn btn-success mr-2' onClick={this.handleSubmitMonthYear}>ค้นหาจากเดืิอน/ปี</button>
                <button type='button' className='btn btn-success' onClick={this.handleDownloadMonthYear}>พิมพ์จากเดืิอน/ปี</button>
              </div>
            </div>
          </div>
        </div>

        {!_.isEmpty(results) && (
          <div>
            <div className='mb-3'>
              <strong>
                รายงานการใช้งานระบบเริ่มตั้งแต่วันที่ 
                {`${moment(this.state.result_start_date, "DD-MM-YYYY").format("DD/MM/YYYY")} ถึง ${moment(this.state.result_end_date, "DD-MM-YYYY").format("DD/MM/YYYY")}`}
              </strong>
            </div>

            <div className='row mb-3 border-bottom'>
              <div className='col-12'>
                <div className='row'>
                  <div className='col-md-6 font-weight-bold'>ประเภท</div>
                  <div className='col-md-2 font-weight-bold'>จำนวน</div>
                  <div className='col-md-2 font-weight-bold'>จำนวนหน้าเอกสาร</div>
                </div>
              </div>
            </div>

            <div className='row mb-3'>
              <div className='col-6'>
                <strong>ทะเบียนหนังสือส่ง</strong>
              </div>
              <div className='col-2'>
                <strong>{results.send_total} ครั้ง</strong>
              </div>
              <div className='col-2'>
                <strong>{results.send_page_count} หน้า</strong>
              </div>
              {isDataFetched && _.map(results.send, this.renderRow)}
            </div>

            <div className='row mb-3'>
              <div className='col-6'>
                <strong>ใบปะหน้า</strong>
              </div>
              <div className='col-2'>
                <strong>{results.front_total} ครั้ง</strong>
              </div>
              <div className='col-2'>
                <strong>{results.front_page_count} หน้า</strong>
              </div>
              {isDataFetched && _.map(results.front, this.renderRow)}
            </div>

            <div className='row mb-3'>
              <div className='col-6'>
                <strong>ทะเบียนหนังสือรับ</strong>
              </div>
              <div className='col-2'>
                <strong>{results.receive_total} ครั้ง</strong>
              </div>
              <div className='col-2'>
                <strong>{results.receive_page_count} หน้า</strong>
              </div>
              {isDataFetched && _.map(results.receive, this.renderRow)}
            </div>

            <div className='row mb-3'>
              <div className='col-6'>
                <strong>รายงานเอกสารที่ถูกดำเนินการ</strong>
              </div>
              <div className='col-2'>
                <strong>{results.operated_count} ฉบับ</strong>
              </div>
            </div>

            <div className='row mb-3'>
              <div className='col-6'>
                <strong>รายงานเอกสารที่ถูกลงนาม</strong>
              </div>
              <div className='col-2'>
                <strong>{results.signed_count} ฉบับ</strong>
              </div>
            </div>

            <div className='mb-3'>
              <strong>จำนวนครั้งของการเข้าใช้งานระบบ E-document ตั้งแต่วันที่ 
                {` ${moment(this.state.result_start_date, "DD-MM-YYYY").format("DD/MM/YYYY")} ถึง ${moment(this.state.result_end_date, "DD-MM-YYYY").format("DD/MM/YYYY")} รวม ${results.grouped_total} ครั้ง`}
              </strong> 
            </div>
            {isDataFetched && _.map(results.grouped, this.renderList)}
          </div>
        )}

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/reports/UsageReportPage.js